<template>
  <div class="customer-management">
    <!-- Header Section -->
    <div class="header-section">
      <div class="header-content">
        <!-- Title Section -->
        <div class="title-section">
          <h1 class="main-title">Customer Management</h1>
          <p class="subtitle">
            Manage customer accounts, addresses, and VIP status
          </p>
        </div>
      </div>
    </div>

    <!-- Customer Management Component -->
    <div class="customer-content">
      <customerManage />
    </div>
  </div>
</template>

<script>
import customerManage from "../../components/back-office/CustomerManagement/CustomerListTable";

export default {
  components: {
    customerManage,
  },

  mounted() {
    this.initializePage();
  },

  methods: {
    initializePage() {
      // Set breadcrumb
      const path = [
        {
          text: "Select province",
          disabled: false,
          href: "/weserve_admin_login/select/",
        },
        {
          text: "Customer Management",
          disabled: true,
        },
      ];
      this.$store.commit("backOffice/saveRecentRoute", path);
    },
  },
};
</script>

<style scoped>
.customer-management {
  min-height: 100vh;
  background: transparent;
}

.header-section {
  padding: 2rem 1rem;
  margin-bottom: 1rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.title-section {
  text-align: left;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: left;
  text-shadow: 2px 3px 12px rgba(33, 33, 32, 0.25);
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  text-align: left;
  margin-bottom: 0;
}

.customer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem 2rem;
}

@media (max-width: 768px) {
  .title-section {
    text-align: center;
  }

  .main-title {
    font-size: 2rem;
    text-align: center;
  }

  .subtitle {
    text-align: center;
  }
}

.customer-management {
  min-height: 100vh;
  background: transparent;
}

.header-section {
  padding: 2rem 1rem;
  margin-bottom: 1rem;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
}

.header-top-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  flex: 1;
  text-align: left;
}

.main-title {
  font-size: 3rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  text-align: left;
  text-shadow: 2px 2px 4px rgba(117, 117, 117, 0.5);
}

.subtitle {
  font-size: 1.2rem;
  color: #7f8c8d;
  text-align: left;
  margin-bottom: 0;
}

.customer-summary-right {
  flex-shrink: 0;
  min-width: 400px;
}

.customer-summary-card {
  border-radius: 12px;
  border: 2px solid #f39c12;
}

.customer-summary-content {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
}

.customer-summary-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
}

.customer-summary-text {
  text-align: left;
}

.customer-total {
  font-size: 1.5rem;
  font-weight: 700;
  color: black;
  margin: 0;
}

.customer-label {
  font-size: 0.9rem;
  color: #333;
  margin: 0;
  font-weight: 500;
}

.customer-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem 2rem;
}

@media (max-width: 768px) {
  .header-top-row {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .title-section {
    text-align: center;
    margin-bottom: 1rem;
  }

  .main-title {
    font-size: 2rem;
    text-align: center;
  }

  .subtitle {
    text-align: center;
  }

  .customer-summary-right {
    min-width: 100%;
  }

  .customer-summary-content {
    flex-direction: column;
    gap: 1rem;
  }

  .customer-summary-item {
    justify-content: center;
  }
}
</style>
